<div class="main-section"> 
    <section class="decode-section">
    <!-- Left Side -->
    <div class="decode-left">
        <h1>Upfront service prices<br />for your car</h1>
        <p>
        Enter your registration number or upload a photo of your number plate.
        We'll auto-detect make, model, and variant to give you accurate estimates.
        </p>

        <div class="features">
        <span class="tag green">✅ Genuine Parts</span>
        <span class="tag blue">✅ Transparent Pricing</span>
        <span class="tag orange">✅ Fast Delivery</span>
        </div>

        <div class="note">No surprises. Prices lock for 48 hours.</div>
    </div>

    <!-- Right Side (Form) -->
<div class="decode-right">
  <div class="form-card">
    <form (ngSubmit)="onDecode()">
      <label for="regNo">Registration Number</label>
      <input
        type="text"
        id="regNo"
        [(ngModel)]="regNo"
        name="regNo"
        placeholder="E.g. AB12 CDE"
        maxlength="13"
        required
        (input)="onRegNoChange()"
        (blur)="regNo = regNo ? formatRegNo(regNo) : regNo"
      />

        <!-- Estimate button -->
        <button
            type="button"
            (click)="onDecode()"
            id="decodeBtn"
            class="btn-estimate"
            [style.backgroundColor]="decodeBtnColor">
            Get My Estimate
        </button>

            <!-- Upload -->
            <div class="upload-number-plate" id="uploadText" *ngIf="!errorMode">
            Or upload number plate photo
            </div>

            <div class="upload-box" id="uploadBox" *ngIf="!errorMode" (click)="fileInput.click()">
            <div class="camera-icon">📷</div>
            <span>Click to upload or drag & drop</span>
            <small>PNG, JPG up to 5MB</small>
            <input
                type="file"
                id="fileInput"
                #fileInput
                (change)="onFileUpload($event)"
                accept="image/png, image/jpeg"
                hidden
            />
            </div>
        </form>

        <!-- Error Card -->
        <div id="errorCard" *ngIf="errorMode" class="error-card">
            <p class="error-message">
            We couldn't auto-identify your car from this number. Please try again
            or select your car manually.
            </p>
            <div class="common-reasons">
            <p>Common reasons:</p>
            <div style="color: #0B2636;">✔ Photo not clear or has glare</div>
            <div style="color: #0B2636;">✔ Temporary or fancy font plates</div>
            <div style="color: #0B2636;">✔ Older registration formats</div>
            </div>
            <button (click)="onTryAgain()" id="tryAgainBtn" class="btn-try-again">🔄 Try Again</button>
            <button id="selectCarBtn" class="btn-select-car" (click)="goToMake()">👉 Select Car Manually</button>
        </div>

        <!-- Notes -->
        <p id="noteSuccess" *ngIf="!errorMode" class="upload-note">
            We auto-detect make, model, variant & size.
        </p>
        <p id="noteError" *ngIf="errorMode" class="upload-note" (click)="goToMake()">
            Manual selection: Make → Model → Variant → Year → Fuel
        </p>
        </div>
    </div>
    </section>
</div> 

<app-loading *ngIf="loading"></app-loading>
